import React, { FC, useState } from 'react'
import { Button, SpinnerIcon } from '@sistemiv/s-components'
import { useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { PlusIcon } from '@heroicons/react/24/outline'
import NoProjectsIcon from '../assets/NoProjectsIcon'
import AddProjectModal from '../components/modals/AddProjectModal'
import { useProjects } from '../repositories/project/projects.repository'
import { useCreateProject } from '../repositories/project/mutations/project-create'
import ProjectsTable from '../components/table/ProjectsTable'

const Home: FC = () => {
  const { org } = useParams()
  const { t } = useTranslation()
  const { data: projects, isLoading: isProjectsLoading } = useProjects()
  const [openProjectModal, setOpenProjectModal] = useState(false)
  const { mutate: addProject, isLoading: addingAcc } = useCreateProject()

  const headers = [
    {
      accessor: 'name',
      label: t('name'),
    },
    {
      accessor: 'lastModified',
      label: t('modified'),
    },
    {
      accessor: 'totalSize',
      label: t('size'),
    },
    {
      accessor: 'actions',
      label: t('actions'),
    },
  ]

  const handleCreateProject = (name: string) => {
    addProject(
      {
        organization: org!,
        name,
      },
      {
        onSuccess: () => {
          setOpenProjectModal(false)
        },
      },
    )
  }

  return (
    <div className='h-full w-full flex overflow-auto'>
      <div className='h-full w-full'>
        <div className='w-full h-[60px] flex justify-between border-b border-gray-300 items-center px-8'>
          <p className='font-sans text-[20px] text-[#262A38]'>{t('projects')}</p>
          <div className='flex gap-x-4'>
            <Button
              className='border border-blue-500 text-blue-500 !rounded-md hover:bg-blue-50'
              onClick={() => setOpenProjectModal(true)}
            >
              <>
                <PlusIcon className='w-4 h-4' />
                {t('project')}
              </>
            </Button>
            {/* <Button className='border border-blue-500 text-blue-500 !rounded-md hover:bg-blue-50'>
              <ArrowUpTrayIcon className='w-4 h-4' /> {t('upload')}
            </Button> */}
          </div>
        </div>
        {isProjectsLoading && (
          <div className='w-full flex justify-center pt-5'>
            <SpinnerIcon className='text-sky-500 h-7 w-7'></SpinnerIcon>
          </div>
        )}
        {!isProjectsLoading &&
          (projects?.projects.length === 0 ? (
            <div className='flex flex-col h-1/2 w-full mx-auto mt-14 items-center justify-start'>
              <NoProjectsIcon className='text-white fill-slate-400 w-20 h-20' />
              <p className='text-slate-400 font-medium'>{t('noProjects')}</p>
            </div>
          ) : (
            <div className='py-6'>
              <ProjectsTable headers={headers} rows={projects?.projects || []} />
            </div>
          ))}
      </div>
      {openProjectModal && (
        <AddProjectModal
          open={openProjectModal}
          setOpen={setOpenProjectModal}
          onCancel={() => setOpenProjectModal(false)}
          onCreate={handleCreateProject}
          creating={addingAcc}
          mode='create'
        />
      )}
    </div>
  )
}

export default Home
